export default {
  getQueryParamsByFiltersState(state) {
    let query = {};
    for (let type of Object.keys(state)) {
      let filterString = state[type].map(o => o.value).join(',');
      if (filterString) {
        query[type] = filterString;
      }
    }
    return query;
  }
};
